<script>
export default {
  data: () => ({
    modal: true
  })
}
</script>

<template>
  <v-dialog
    ref="migrationDialog"
    v-model="modal"
    width="80%"
    close-on-click
  >
    <v-card>
      <v-card-title class="headline">Novidades Empolgantes!</v-card-title>
      <v-card-text>
        <h3>O MeuClinic está evoluindo! 🚀</h3>
Prezado Usuário,
<br><br>
Estamos felizes em anunciar que esta plataforma estará progredindo para uma nova versão a partir do dia <strong>14/12/2023</strong>! Esta atualização traz uma série de recursos empolgantes e melhorias para aprimorar sua experiência geral. Ouvimos seus feedbacks e trabalhamos arduamente para tornar o Clinic ainda melhor, e com uma presença marcante na WEB.
<br><br>
<h3>O que há de Novo</h3>
<ul>
  <li><h4>Novo visual</h4>O Clinic está de cara nova, com um visual mais moderno e agradável.</li>
  <li><h4>Agenda aprimorada</h4>Apresentamos uma nova agenda, mais clara e intuitiva.</li>
  <li><h4>Prontuário eletrônico</h4>Faça evoluções e veja o histórico do paciente de forma mais clara.</li>
  <li><h4>Segurança</h4>A segurança dos seus dados é nossa prioridade. Por isso, estamos migrando para uma nova plataforma, com tecnologia de ponta e muito mais segura.</li>
</ul>
<br>
Além dos novos recursos, também fizemos vários aprimoramentos e correções de bugs para garantir que o MeuClinic funcione sem problemas. Seu feedback é inestimável, e agradecemos sua paciência enquanto continuamos a refinar e melhorar o aplicativo.
<br><br>
<h3>Como Atualizar</h3>
Para desfrutar dos recursos e melhorias mais recentes agora mesmo, basta acessar <a href="https://meu.clinic.com.br">meu.clinic.com.br</a>.
Caso tenha alguma dúvida, entre em contato com o nosso suporte pelo e-mail <a href="mailto:suporte@clinic.med.br"></a>
<br><br>
<h3>Queremos Seu Feedback</h3>
Como sempre, seu feedback é crucial para nos ajudar a moldar o futuro do MeuClinic. Se encontrar algum problema, tiver sugestões ou simplesmente quiser compartilhar seus pensamentos, não hesite em nos contatar.
<br><br>
Agradecemos por ser parte valiosa da comunidade MeuClinic. Esperamos que você aproveite as últimas melhorias e recursos!
<br><br>
Atenciosamente,
<br>
Clinic.
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <!-- <v-btn color="green darken-1" flat @click="modal = false">Disagree</v-btn> -->
        <v-btn color="green darken-1" flat @click="modal = false">Ok</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>



// WEBPACK FOOTER //
// src/components/migrationDialog/index.vue